<script>
  export default {
    name: 'SymbolsLayout',
    props: {
      /** collection of characters in selected letter style */
      lettersData: {
        type: Array,
        required: true
      },
    },
    computed: {
      /** returns only letters of type uppercase */
      filteredLettersData() {
        return this.lettersData.filter(function (letter) {
          return letter.type !== 'lower';
        });
      },
      /** Determines if there is a heart charcter in the letter set */
      hasHeartChar() {
        return this.lettersData.filter(function (letter) {
          return letter.class === 'heart';
        });
      }
    },
  };
</script>

<template>
  <div class="letter-edit__showcase">
    <div class="letter-edit__showcase-header">
      <h4 class="letter-edit__showcase-heading">Available Characters :</h4>
      <p v-show="hasHeartChar" class="letter-edit__showcase-instructions">For a heart, type an asterisk (*)</p>
    </div>
    <div class="letter-showcase">
      <div class="letter-showcase__inner js-custom-plate__showcase">
        <span
          v-for="letter in filteredLettersData"
          :key="letter.id"
          :class="'letter-showcase__char m-' + letter.class + ' m-' + letter.type"
          :style="{ backgroundImage: 'url(' + letter.image + ')' }"
        />
      </div>
    </div>
  </div>
</template>
